/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-plusplus */
import { useContext } from 'react';
import { Context } from '../../context/MainProvider.js';

const useTranslate = (keys, defaultValue) => {
  if(!keys) return;
  const { translations, language, showTranslationKeys } = useContext(Context) || {};
  if (typeof keys === 'string') {
    keys = [keys];
  }

  let value = defaultValue;
  for (let i = 0; i < keys.length; i++) {
    const translationValue = translations.edges.find(
      (n) => n.node.key === keys[i] && n.node.language === language
    );

    if (translationValue) {
      value = translationValue.node.value;
      break;
    }
  }



  return showTranslationKeys ? keys[0] : value;
};

export default useTranslate;
